import React, {Component} from 'react';

import {postExcelData, saveMOQ, getMOQbyItem, getMOQbyVendor, getMOQbyItemAndVendor, deleteMOQ, getMOQInfo} from '../../../actions/index';
import SearchBar from '../../components/SearchMOQ/SearchMOQ';
import MOQTable from '../../components/MOQTable/MOQTable';
import UploadButton from '../../components/UploadButton/UploadButton';
import Modal from '../../components/ModalMOQ/Modal';
import './styles.css';

import ModalUnsave from '../../components/Modal-unsave/Modal';
import NotificationLoading from '../../components/Notification-loading/Notification-loading';
import NotificationSuccess from '../../components/Notification-success/Notification-success';
import NotificationPopUp from '../../components/NotificationPopUp/NotificationPopUp'
import NotificationError from '../../components/Notification-error/Notification-error'
import ModalErrorData from '../../components/ModalErrorData/ModalErrorData';

import ModalUnsavePage from '../../components/Modal-unsave-page/Modal';

import * as FileSaver from 'file-saver';


class MOQMaintenance extends Component {

    constructor(props) {
        super(props)  
        this.state = {
            data: [],
            show: false,
            showUnsavedModal: false,
            showUnsavedModalPage: false,
            showNotification: false,
            showNotificationSuccess: false,
            showNotificationError: false,
            isSaved: false,
            isUpload: false,
            showErrorDataModal: false,
            showNotificationPopup: false,
            errorUploadData: [],
            messageError: []
        };   
        this.itemToSend;
        this.itemToDelete;
        this.dataGrill;
        this.tableChangeHandle = React.createRef();
    }

    openModal = e => {
        this.setState({
            show: !this.state.show
        });
    }

    openUnsavedModal = () => {
        this.setState({
            showUnsavedModal: !this.state.showUnsavedModal
        });
    }

    openErrorDataModal = () => {
        this.setState({
            showErrorDataModal: !this.state.showErrorDataModal
        });
    }

    openNotificationPopup = () => {
        this.setState({
            showNotificationPopup: !this.state.showNotificationPopup
        });
    }

    openUnsavedModalPage = () => {
        this.setState({
            showUnsavedModalPage: !this.state.showUnsavedModalPage
        });
    }

    onClose = e => {
        this.props.show = false;
    };

    onGetExcelData = (excelData) => {
        const data = {
            data: excelData
        }
        this.openNotification(true);
        if(data.data[0].hasOwnProperty('__EMPTY')) {
            const message = `Excel file must meet the following criteria: headers must be in row #1 column A, Headers name should match the required and are case sensitive: 
            Item, Vendor Number, Warehouses, Item Vendor MOQ, Item Vendor DC MOQ`;
            this.openNotification(false);
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 8000);
            });
        } else {
            postExcelData(data).then(res => {
                this.openNotification(false);
                if(res.data.success == true) {  
                    res.data.data.map((data,index) => {
                        data.masterIndex = index;
                        data.uploadedData = true;
                    })
                    this.setState({data: res.data.data});
                } else {
                    const data = res.data.dataError;
                    this.setState({errorUploadData: data}, function() {
                        this.openErrorDataModal();
                    });
                    let message = "Error in some data fields, please check the logs.";
                    this.setState({messageError: message}, function() {
                        this.openNotificationError(true); 
                        setTimeout(() => { this.openNotificationError(false) }, 15000);
                    });
                }
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        }   
    }

    onAddItemData = (data) => {
        postExcelData(data).then(res => {
            this.openNotification(false);
            if (res.data.success){
                data.uploadedData = true;
                this.setState({data: res.data.data});
            } else {
                const errors = [];
                res.data.dataError.forEach(function (item, index) {
                    errors.push(item.message + " ");
                });
                this.setState({messageError: errors}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 15000);
                });
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    itemSearchData = (item) => {
        this.setState({itemSearch: item});
    }

    vendorSearchData = (vendor) => {
        this.setState({vendorSearch: vendor});
    }


    getItemToSend = (item) => {
        this.itemToSend = item;
    }

    getItemToDelete = (item) => {
        this.itemToDelete = item;
    }

    saveMOQ = () => {
        if(this.state.data.length > 0) {
            const userId = sessionStorage.getItem("uId");
            this.dataGrill = [];
            if (this.itemToSend !== undefined){
                this.dataGrill = {
                    audit: {userId: userId},
                    data: this.itemToSend
                };
                this.itemToSend = undefined;
            } else {
                this.dataGrill = {
                    audit: {userId: userId},
                    data: this.state.data
                };
            }

            this.openNotification(true);
            saveMOQ(this.dataGrill).then(res => {
                if(res.data.success == true) { 
                    res.data.data.map((data,index) => {
                        data.masterIndex = index;
                    })
                    this.setState({data: res.data.data, filterItem: null,filterVendor: null});
                    this.setState({isSaved: true});
                    this.openNotification(false);
                    this.openNotificationSuccess(true);
                    setTimeout(() => { this.openNotificationSuccess(false) }, 3000);
                } else {
                    this.setState({data: this.dataGrill.data});
                    const data = res.data.messages;
                    if (data[0].code === 'Audit'){
                        this.setState({messageError: data[0].text}, function() {
                            this.openNotificationError(true); 
                            setTimeout(() => { this.openNotificationError(false) }, 5000);
                        });
                    } else {
                        this.setState({messageError: data}, function() {
                            this.openNotificationPopup();
                        });
                    }
                }
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(typeof err.response === 'undefined') {
                    message = err.message
                } else {
                    if (err.response.status === 401) {
                        message = 'The authentication token expired, please re-login and try again.'
                    } else {
                        message = err.message
                    }
                }
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
            this.openNotification(false);
        } else {
            this.setState({messageError: 'No changes to save'}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 2000);
            });
        }   
    }

    deleteMOQ = () => {
        if(this.itemToDelete) {
            let idsToDelete = this.itemToDelete.map(data => data.masterIndex);
            let result = this.state.data.filter(data => idsToDelete.indexOf(data.masterIndex) === -1)
            this.setState({data: result});
            const data = {
                data: this.itemToDelete
            };
            deleteMOQ(data).then(res => {
                this.triggerDelete();
                this.itemToDelete = [];
            }).catch(err => {
                let message;
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        }  
    }

    triggerSearchItem = (trigger) => {
            this.openNotification(true);
            const item = this.state.itemSearch;
            if(item == undefined || item.length == 0) { 
                getMOQInfo().then(res => {
                    this.openNotification(false);
                    res.data.data.map((data,index) => {
                        data.masterIndex = index;
                    })
                    this.setState({data: res.data.data, filterItem: null,filterVendor: null});
                }).catch(err => {
                    let message;
                    this.openNotification(false);
                    if(err.response.status === 503)  message = err.response.data.errors[0].title
                    if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                    this.setState({messageError: message}, function() {
                        this.openNotificationError(true); 
                        setTimeout(() => { this.openNotificationError(false) }, 5000);
                    });
                });
            } else {
                getMOQbyItem(item).then(res => {
                    this.openNotification(false);
                    if(res.data.success == false) {  
                        this.setState({messageError: res.data.messages[0].text}, function() {
                            this.openNotificationError(true); 
                            setTimeout(() => { this.openNotificationError(false) }, 2000);
                        });
                    } else {
                        res.data.data.map((data,index) => {
                            data.masterIndex = index;
                        })
                        this.setState({data: res.data.data, filterItem: null,filterVendor: null});
                    }
                }).catch(err => {
                    let message;
                    this.openNotification(false);
                    if(err.response.status === 503)  message = err.response.data.errors[0].title
                    if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                    this.setState({messageError: message}, function() {
                        this.openNotificationError(true); 
                        setTimeout(() => { this.openNotificationError(false) }, 5000);
                    });
                });
            }
    }
    
    triggerSearchVendor = (trigger) => {
            this.openNotification(true);
            const vendor = this.state.vendorSearch;
            getMOQbyVendor(vendor).then(res => {
                this.openNotification(false);
                if(res.data.success == false) {  
                    this.setState({messageError: res.data.messages[0].text}, function() {
                        this.openNotificationError(true); 
                        setTimeout(() => { this.openNotificationError(false) }, 2000);
                    });
                } else {
                    res.data.data.map((data,index) => {
                        data.masterIndex = index;
                    })
                    this.setState({data: res.data.data, filterItem: null,filterVendor: null});
                }
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
    }

    triggerSearchItemVendor = (item, vendor) => {
        this.openNotification(true);
        getMOQbyItemAndVendor(item, vendor).then(res => {
            this.openNotification(false);
            if(res.data.success == false) {  
                this.setState({messageError: res.data.messages[0].text}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 2000);
                });
            } else {
                res.data.data.map((data,index) => {
                    data.masterIndex = index;
                })
                this.setState({data: res.data.data});
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    filterItem = (item) => {
        this.setState({filterItem: item, type: "item"});
    }

    filterVendor = (vendor) => {
        this.setState({filterVendor: vendor, type: "vendor"});
    }

    onDataModal = (hasData) => {
        this.openUnsavedModal();
    }

    discardChanges = (discard) => {
        this.openUnsavedModal();
        this.openModal();
    }

    discardChangesPage = (discard) => {
        this.props.history.push("/");  
    }

    saveModalPage = (save) => {
        this.openUnsavedModalPage();
        this.saveMOQ();
    }

    CloseWindow = () => {
        if(this.state.isSaved === false && this.state.data.length > 0) {
            this.openUnsavedModalPage();
        } else {
            this.discardChangesPage(true);   
        } 
    }

    triggerCancel = () => {
        this.tableChangeHandle.current.onCancelChange();
    }

    triggerExport = () => {
        this.openNotification(true);
        if(this.state.data.length == 0) {
            getMOQInfo().then(res => {
                this.tableChangeHandle.current.onExportToExcel(res.data.data);
                this.openNotification(false);
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        } else {
            this.openNotification(false);
            this.tableChangeHandle.current.onExportToExcel(null);
        }
    }

    triggerDelete = () => {
        this.tableChangeHandle.current.onDeleteData();
    }

    openNotification = (show) => {
        this.setState({
            showNotification: show
        });
    }

    openNotificationSuccess = (show) => {
        this.setState({
            showNotificationSuccess: show
        });
    }

    openNotificationError = (show) => {
        this.setState({
            showNotificationError: show
        });
    }

    createTemplateExcel = async () => {

        const XLSX = await import("xlsx");
        
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const dataTemplate = [{
            "Item": "",
            "Vendor Number": "",
            "Warehouses": "",
            "Item Vendor MOQ": "",
            "Item Vendor Multiple": "",
            "Item Vendor Per PO": ""
        }]


        const ws = XLSX.utils.json_to_sheet(dataTemplate);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, 'Template-File-MOQ' + fileExtension);
    }
    

    render() {
        return(
            <div className="container-fluid">
                <h3 className="page-title">Direct Import Item Vendor MOQ Maintenance</h3>
                <SearchBar itemSearch={this.itemSearchData} vendorSearch={this.vendorSearchData}  triggerSearchItem={this.triggerSearchItem} triggerSearchVendor={this.triggerSearchVendor} triggerSearchItemAndVendor={this.triggerSearchItemVendor} filterItem={this.filterItem}  filterVendor={this.filterVendor}/>
                <Modal onClose={this.openModal} show={this.state.show} onAddItemData={this.onAddItemData} onData={this.onDataModal} openNotification={this.openNotification}/>
                <ModalUnsave showw={this.state.showUnsavedModal} onClose={this.openUnsavedModal} onDiscard={this.discardChanges}/>
                <MOQTable responseData={this.state.data} itemSend={this.getItemToSend} itemDelete={this.getItemToDelete} filterItem={this.state.filterItem}
                 filterVendor={this.state.filterVendor} ref={this.tableChangeHandle} type={this.state.type}/>
                <div className="actionss-container">
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.CloseWindow}>Close</button>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.createTemplateExcel}>Create Template</button>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.triggerExport}>Export</button>
                    <button type="button" className="btn btn-warning actions-button close-p2 btn-sm" onClick={this.openModal}>Add MOQ</button>
                    <UploadButton  onGetExcelData={this.onGetExcelData} openNotification={this.openNotification}/>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.triggerCancel}>Cancel</button>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.deleteMOQ}>Delete</button>
                    <button type="button" className="btn btn-warning actions-button btn-sm" onClick={this.saveMOQ}>Save</button>
                </div>
                <NotificationLoading show={this.state.showNotification} onClose={this.openNotification}/>
                <NotificationSuccess show={this.state.showNotificationSuccess} onClose={this.openNotificationSuccess}/>
                <NotificationError show={this.state.showNotificationError} onClose={this.openNotificationError} message={this.state.messageError}/>
                <NotificationPopUp show={this.state.showNotificationPopup} onClose={this.openNotificationPopup} data={this.state.messageError}/>
                <ModalUnsavePage show={this.state.showUnsavedModalPage} onClose={this.openUnsavedModalPage} onDiscard={this.discardChangesPage} onSave={this.saveModalPage}/>
                <ModalErrorData show={this.state.showErrorDataModal} onClose={this.openErrorDataModal} data={this.state.errorUploadData}/>
            </div>
        );
    }

}

export default MOQMaintenance;